import React from 'react'

import { getBranchOwner, api, get, put } from "@config"
import { notification } from 'antd'
import {
    saveProduct, partialUpdate
} from '../../components/pages/products/utils'


const fields = [
    {
        field: 'name',
        selector: '[controlid="product-name"]'
    },
    {
        field: 'code',
        selector: '[controlid="product-code"]'
    },
    {
        field: 'price',
        selector: '[data-control-id="product-price"]'
    },
    {
        field: 'cost',
        selector: '[data-control-id="product-cost"]'
    },
    {
        field: 'unit-select',
        selector: '[controlid="product-unit-select"]'
    }
]

export default class Product {

    constructor() {
        this.data = {}
        this.errors = []
        this.automaticBaseValidate = true
        this.automaticFiscalValidate = true
        this.fiscalErrors = []
        this.baseIsValid = false
        this.fiscalDataIsValid = false
        this.fiscalValidate = true
        this.showErrorsMode = 'notification'
        this.branch = null
        this.obj = false
    }

    errorsNotification() {
        if (this.fiscalErrors.length > 0) {
            this.errors = this.errors.concat(this.fiscalErrors)
        }
        notification.open({
            type: "error",
            message: "Corrija os erros",
            description: <ul>{this.errors.map((e, i) => <li key={i}>{e}</li>)}</ul>,
            duration: 3,
            key: 123,
        })
    }

    initFromProps(props) {
        this.branch = getBranchOwner()
        this.data.name = props.name
        this.data.barcode = props.barcode
        this.data.ref_code = props.code
        this.data.price = props.price
        this.data.cost = props.cost
        this.data.unit = props.unit.id
        this.data.category = props.category.id
        if (props.initialStock) {
            this.data.stock = {}
            this.data.stock.quantity = props.initialStock
        }

        if (this.branch.is_fiscal) {
            this.data.fiscal = {}
            this.data.fiscal.ncm = props.ncm.id
            this.data.fiscal.cfop = props.cfop.id
            this.data.fiscal.template_icms = props.icms.id
            this.data.fiscal.template_pis = props.pis.id
            this.data.fiscal.template_ipi = props.ipi.id

            if (props.cest) this.data.fiscal.cest = props.cest.id
        }
        if (this.automaticBaseValidate) {
            this.baseValidate()
        }
        if (this.branch.is_fiscal && this.automaticFiscalValidate) {
            this.validateFiscalData()
        }
    }

    clearBorderColor() {
        fields.forEach(field => {
            const e = document.querySelector(field.selector)
            if (e) {
                e.style.borderColor = ""
            }

        })
    }
    addFieldError(name) {
        fields.forEach(f => {
            if (f.field === name) {
                let comp = document.querySelector(f.selector)
                if(comp) {
                    comp.style.borderColor = "red"
                }
            }
        })
    }
    validateFiscalData() {
        this.fiscalErrors = []
        if (!this.data.fiscal.ncm) {
            this.fiscalErrors.push("Informe o NCM")

        }
        if (!this.data.fiscal.cfop) {
            this.fiscalErrors.push("Informe o CFOP")

        }
        if (!this.data.fiscal.template_icms) {
            this.fiscalErrors.push("Informe o ICMS")

        }
        this.fiscalDataIsValid = this.fiscalErrors.length === 0
    }

    baseValidate() {
        this.clearBorderColor()
        this.errors = []

        if (!this.data.name) {
            this.addFieldError('name')
            this.errors.push('O Nome do produto é inválido')
        }
        if (!this.data.ref_code && !this.obj) {
            this.addFieldError('code')
            this.errors.push('O Código do produto é inválido')
        } 

        if (this.data.price <= 0) {
            this.addFieldError('price')
            this.errors.push('O Preço do produto é inválido')
        }

        if (this.data.cost) {
            if (this.data.cost > this.data.price) {
                this.errors.push('Preço de custo maior do que preço de venda')
                this.addFieldError('cost')
            }
        }
        if (!this.data.unit) {
            this.addFieldError('unit-select')
            this.errors.push('Informe a unidade')
        }
        this.baseIsValid = this.errors.length === 0
    }

    save(successPayload = () => { }, errorPayload = () => { }) {
        const condition = this.errors.length > 0 || (this.branch.is_fiscal && this.fiscalErrors.length > 0)
        if (condition && !this.obj) {
            errorPayload(this.errors)
            switch (this.showErrorsMode) {
                case 'notification':
                    this.errorsNotification()
                    break
                case 'inline':
                    this.inlineErrors()
                    break

            }
        } else { 
            if (this.obj) { 
                // delete this.data.code
                const branch = getBranchOwner().id
                const url = `${api.products.products}${this.data.id}/?branch_owner=${branch}`
                const payload = product => successPayload(product)
                put(url, this.data, payload, errorPayload)
            } else { 
                saveProduct(this.data, successPayload, errorPayload)
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/models/base/product.js